import { render, staticRenderFns } from "./questionnaireManagementEdit.vue?vue&type=template&id=1b6a628a&scoped=true&"
import script from "./questionnaireManagementEdit.vue?vue&type=script&lang=js&"
export * from "./questionnaireManagementEdit.vue?vue&type=script&lang=js&"
import style0 from "./questionnaireManagementEdit.vue?vue&type=style&index=0&id=1b6a628a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6a628a",
  null
  
)

export default component.exports